import BaseListStore from 'stores/base/BaseListStore'

import Field, { IFieldCreatePayload } from './Field'

import getFieldId from 'utils/getFieldId'

class FieldStore extends BaseListStore<Field, IFieldCreatePayload> {
  constructor() {
    super(Field)
  }

  getByName(fieldName: string, modelId: string) {
    return this.get(getFieldId(modelId, fieldName))
  }
}

export default new FieldStore()
